import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyVariable = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – Variable</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this tutorial, we will learn about variables in Python.
                    we will also discuss to define a variable, assign a value to
                    variables in Python.
                  </p>
                </div>
                <h1 className="py_h1">What is Variable:</h1>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <ul style={{ color: "white" }}>
                    <li>In Python, variables are a memory location.</li>
                    <li>It can store values like numbers and text.</li>
                    <li>The value of a variable can be changed.</li>
                    <li>
                      The variable is always assigned with the equal(=) sign.
                    </li>
                  </ul>
                </div>
                <div className="col-md-4"></div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>x=10</p>
                  <p>
                    y=<span className="python-string">"Learn Python"</span>
                  </p>
                  <p>
                    <span className="python-function">print</span>(x)
                  </p>
                  <p>
                    <span className="python-function">print</span>(y)
                  </p>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: Python is a dynamically typed language, so, you need
                    not to declare type of a variable.
                  </p>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Python – Variable</h1>
                <hr style={{ color: "white" }} />
                <div>
                  <p>
                    In Python, the variable assignment can be done by using
                    equal(=) symbol. One or more values can assign in variables.
                    <br />
                    We can assign a single value to a variable.
                  </p>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>#single value assignment in a variable</p>
                  <p>n=10</p>
                  <p>
                    <span className="python-function">print</span>(n)
                  </p>
                </div>
                <p> We can assign multiple values to a single variable.</p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>#multiple values assignment in a variable</p>
                  <p>n=10,20,30 </p>
                  <p>
                    <span className="python-function">print</span>(n)
                  </p>
                </div>
                <p>And we can assign multiple values to multiple variables.</p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <p>#multiple values assignment in multiple variables</p>
                  <p>a,b,c=10,20,30</p>
                  <p>
                    <span className="python-function">print</span>(a)
                  </p>
                  <p>
                    <span className="python-function">print</span>(b)
                  </p>
                  <p>
                    <span className="python-function">print</span>(c)
                  </p>
                </div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Rules for Naming Variables</h1>
                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-7">
                  <ul style={{ color: "white" }}>
                    <li>
                      The variable name can be a combination of letters,
                      numbers, and underscore.
                    </li>
                    <li>
                      The first character of a variable name should not be a
                      number, it must start with a character or underscore.
                    </li>
                    <li>
                      A variable name can have both uppercase and lowercase or a
                      combination of both cases.
                    </li>
                    <li>
                      Variable name should not be a reserved keyword(predefined
                      word in Python).
                    </li>
                    <li>Name of the variable should be meaningful.</li>
                  </ul>
                </div>
                <div className="col-md-2"></div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
